import { createContext } from "react";

interface UserType{
    _id:string,
    name:string,
    surname:string,
    description?: string
}

export const userListRecord = createContext<Record<string,UserType>>({})

interface AuthProvideType{
    token: string,
    id: string,
    admin: boolean
}

export const AuthProvider = createContext<AuthProvideType>({token:"",id:"", admin: false})